import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useApiClient } from '../clients/ApiClient'
import { PageQuery, toQueryParam } from '../../utils/models/pageQuery'
import { PagedResponse } from '../models/responses/pagedResponse'
import { Country } from '../../core/models/entities/Country'
import { Resource } from '../../core/models/wrappers/Resource'
import { mapToCountry } from '../models/mappers/mapCountry'

export interface CountryRepository {
  useAllCountries(query: PageQuery): Resource<PagedResponse<Country>>
  prefetchAllCountries(query: PageQuery): Promise<void>
}

export function useCountryRepository(): CountryRepository {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  function useAllCountries(query: PageQuery): Resource<PagedResponse<Country>> {
    return useQuery(['countries', toQueryParam(query)], () => apiClient.getAllCountries(query).then((data) => ({ ...data, results: data.results.map(mapToCountry) })), { staleTime: 600000 })
  }

  // Cache-warming twin of useAllCountries (same key/queryFn/staleTime), fail-silent.
  function prefetchAllCountries(query: PageQuery): Promise<void> {
    return queryClient.prefetchQuery(['countries', toQueryParam(query)], () => apiClient.getAllCountries(query).then((data) => ({ ...data, results: data.results.map(mapToCountry) })), { staleTime: 600000 })
  }

  return {
    useAllCountries,
    prefetchAllCountries,
  }
}

